import { render, staticRenderFns } from "./SubmitBar.vue?vue&type=template&id=48831e8e&"
import script from "./SubmitBar.vue?vue&type=script&lang=js&"
export * from "./SubmitBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports